import React, {useEffect, useMemo, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import Styles from './index.module.scss'
import NFTModal from "@/components/NFTModal";
import ActivityRules from "../components/ActivityRules";
import Service from "../service"
import {hideLoading, showLoading} from "@/components/loading";
import {Toast} from "antd-mobile";
import {Platform} from "@/utils/publicFun";
import shareTipImg from "@/assets/img/culturalExchange_huaju/sharetip.jpg";

/**
 * @description 话剧盲盒活动首页
 * @return {/culturalExchange_huaju/home}
 */
const Btns = [
  { title: '规则', key: 1 }, { title: '实名', key: 2 },
]
/** 话剧抽奖 H5 入口（域名随环境：REACT_APP_GKT_LINK） */
const LOTTERY_URL = `${process.env.REACT_APP_GKT_LINK}/front/activities/geographyLottery/home?activityCode=dramaBlindBox`;
/** 角色/配件盲盒 collectionId，与接口 productId 一致 */
const DRAMA_COLLECTION_ID = {
  character: Service.characterCollectionId,
  accessory: Service.accessoryCollectionId,
};

const Home = () => {
  const pageDom = useRef(null);
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState({});
  const [data, setData] = useState({});
  const isWechat = Platform.isWechat();
  const isApp = Platform.isApp();

  useEffect(() => {
    if (isWechat) return;
    getData(true);
    onDidFocus();
  }, []);

  const onDidFocus = () => {
    window.JsBridge.addListener().then(() => {
      getData(true)
      onDidFocus();
    });
  }
  const getData = async (loading = false) => {
    try {
      if (loading) showLoading();
      if (loading) {
        await Service.getActivityRules(); // 解决没有 token 的问题
        const userInfoRes = await Service.getUserCertificateStatus();
        setUserInfo(userInfoRes);
      }
      // 话剧活动首页初始化：返回 startTime / endTime / systemTime
      const res = await Service.getInitData();
      if (loading) hideLoading();
      if (res.code !== '000000') throw res.msg;
      setData(res.data || {});
    } catch (error) {
      hideLoading();
      Toast.show(error);
    }
  }

  const onBack = () => {
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.back();
    } else {
      navigate(-1);
    }
  }

  const navigateTo = (uri) => {
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.push("CustomWeb", { uri: `${window.location.origin}${uri}` });
    } else {
      navigate(uri);
    }
  }

  const toExchange = () => {
    navigateTo('/culturalExchange_huaju/exchangepage');
  }

  const toSynthesizedCollection = () => {
    navigateTo('/culturalExchange_huaju/exchangeRecord');
  }

  // 提示信息
  const tipsMessage = useMemo(() => {
    let msg = undefined;
    const { systemTime, startTime, endTime } = data;
    const currentT = new Date(systemTime?.replace(/-/g, "/")).getTime();
    const startT = new Date(startTime?.replace(/-/g, "/")).getTime();
    const endT = new Date(endTime?.replace(/-/g, "/")).getTime();
    if (!startTime || !endTime) {
      msg = "接口异常";
    } else if (currentT < startT) {
      msg = "活动未开始";
    } else if (currentT > endT) {
      msg = "活动已结束";
    }

    return msg;
  }, [data]);

  const buyHandle = (productType) => {
    if (tipsMessage) {
      Toast.show(tipsMessage);
      return;
    }
    if (!Service.isUserVerified(userInfo)) {
      Toast.show("请先实名认证");
      return;
    }
    const collectionId = DRAMA_COLLECTION_ID[productType];
    if (!collectionId) return;
    navigateTo(`/ape/saleDetail?collectionId=${collectionId}&code=${Service.activityCode}`);
  }
  const onRightBtnClick = (item) => {
    if (item.key === 1) {
      const ModalInstance = NFTModal.show({
        content: <ActivityRules onClose={() => ModalInstance?.close()} />,
        getContainer: pageDom.current,
      });
    } else if (item.key === 2) {
      window.JsBridge.navigate('Verify');
    }
  }

  // 微信内打开仅展示分享引导图
  if (isWechat) {
    return (
      <div className={Styles.wechatShareTip}>
        <img src={shareTipImg} alt="" />
      </div>
    );
  }

  return (
    <div className={Styles.culturalExchangeHome} ref={pageDom}>
       <div className={Styles.topCard}>

      </div>
      {isApp ? (
        <div className={Styles.back} onClick={onBack}></div>
      ) : null}
      <div className={Styles.right_btns}>
        {
          Btns.map((btn, i) => {
            if (btn.key === 2 && Service.isUserVerified(userInfo)) return null;
            return (
              <div key={i} className={Styles.rightBtn} onClick={() => onRightBtnClick(btn)}>{btn.title}</div>
            )
          })
        }
      </div>
      <div className={Styles.bottomBtnBox}>
        <div className={Styles.goSynthesisBtn} onClick={toExchange} />
        <div className={Styles.synthesizedBtn} onClick={toSynthesizedCollection} />
      </div>

      <div
        className={`${Styles.buyNowBtn} ${Styles.characterBuyBtn}`}
        style={{ filter: tipsMessage ? 'grayscale(1)' : '' }}
        onClick={() => buyHandle('character')}
      />
      <div
        className={`${Styles.buyNowBtn} ${Styles.accessoryBuyBtn}`}
        style={{ filter: tipsMessage ? 'grayscale(1)' : '' }}
        onClick={() => buyHandle('accessory')}
      />

      <div className={Styles.raffleSection}>
        <div className={Styles.raffleTipItem}>
          <div className={Styles.raffleTipTitle}>普通款</div>
          <div className={Styles.raffleTipDesc}>可获得 <span>1 次抽奖机会</span></div>
        </div>
        <div className={Styles.raffleTipItem}>
          <div className={Styles.raffleTipTitle}>稀有款</div>
          <div className={Styles.raffleTipDesc}>可获得 <span>4 次抽奖机会</span></div>
        </div>
        <div
          className={Styles.raffleBtn}
          onClick={() => {
            if (tipsMessage) {
              Toast.show(tipsMessage);
              return;
            }
            const token = window.localStorage.getItem('token') || '';
            const userCode = userInfo?.loginName || '';
            const uri = `${LOTTERY_URL}&t=${encodeURIComponent(token)}&userCode=${encodeURIComponent(userCode)}&type=2`;
            if (window.JsBridge.hasWebViewBridge()) {
              window.JsBridge.push('CustomWeb', { uri });
            } else {
              window.location.href = uri;
            }
          }}
        />
      </div>

      <div className={Styles.footerBox}>
        <div className={Styles.footer}></div>
      </div>
    </div>
  )
}
export default Home
